import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TrashCanFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TrashCanFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M15 .5V2h6v3H3V2h6V.5h6ZM8 23.5c-2.21 0-4-1.79-4-4V7h16v12.5c0 2.21-1.79 4-4 4H8Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default TrashCanFilled;